import apiUrl from "../../../constants";
import axios from "axios";
import CryptoJS from "crypto-js";
import VueElementLoading from "vue-element-loading";
import Paginate from "vuejs-paginate";
import { BasicSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import download from "downloadjs";
import moment from "moment";
import jsPDF from "jspdf";
import utils from "../../../utils/validateScanner";
import JsBarcode from 'jsbarcode';

export default {
  name: "DockMaster",
  mixins: [utils],
  components: {
    BasicSelect,
    Multiselect,
    VueElementLoading,
    download,
    Paginate,
  },
  data: function () {
    return {
      hubId: "",
      createdBy: "",
      componentKey: 0,
      isLoadingUpload: false,
      isLoadingSearch: false,
      failed: [],
      fileDetails: [],
      addmodalShow: false,
      configFileLogs: [],
      showModal: false,
      url: "",
      configFile: "",
      currentTab: "upload",
      tabs: [
        {
          key: "upload",
          value: "Dock Config Upload",
        },
        {
          key: "history",
          value: "History",
        },
        {
          key: "print",
          value: "Print Barcode",
        },
      ],

      hubLoading: "",
      isLoading: false,
      dockFileData: [],
      pageno: 0,
      pageCount: 0,
      totalRows: 0,
      limit: 10,
      hubName: "",
      isEditingDock: false,
      editDockForm: {
        rowId: null,
        fileId: null,
        dock_id: "",
        dock_type: "",
        max_vehicles: "",
        vehicle_capacity: "",
        dock_height: "",
        weighing_type: "",
        preferred_bu: "",
        status: "",
        camera_name: "",
        modifiedBy: "",
      },
      editDockErrors: {
        max_vehicles: "",
        vehicle_capacity: "",
        dock_height: "",
      },
      deleteModalShow: false,
      deleteRowId: "",
      filterOperation: { text: "", value: "" },
      operationOptions: [
        { text: "Operational", value: "1" },
        { text: "Non-Operational", value: "2" },
        { text: "Under Maintenance", value: "3" }
      ],
      filterhubId: "",
      filterDockId: "",
      hubnameerror: "",
      selectedConfig: null,
      pendingActiveState: null,
      modalActionText: "",
      modalPromptText: "",
      dockTypeOptions:[
        {
          text:"Running" ,value:"1"
        },
        {
          text:"Standalone" ,value:"2"
        },
        
      ],
      selectedDockType: null,
      barcodeList:[],
      printbarcode:[]
    };
  },
  computed: {
    currentTabComponent: function () {
      this.componentKey += 1;
      return this.currentTab.toLowerCase();
    },
  },

  filters: {
    moment: function (date) {
      if (date == "" || date == null) {
        return "--";
      }
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    moment1: function (timestamp) {
      const convertTimestamp = new Date(timestamp)
        .toLocaleString("en-GB", {
          timeZone: "UTC",
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
        .replace(/(\d+)\/(\d+)\/(\d+), (\d+):(\d+):(\d+)/, "$1-$2-$3 $4:$5:$6");
      return convertTimestamp;
    },
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem("userdetail");
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdBy = userdetail[0].email;
    this.hubId = userdetail[0].HubId[0];
    this.getHubName(userdetail[0].HubId);

    this.hubForManualRestriction();

    this.getActiveFileData();
    this.getHubList();
  },
  methods: {
    secondFunction(tab) {
      this.currentTab = tab.key;
      this.componentKey++;

      if (tab.key == "history") {
        this.resetForm();
        this.getConfigFile();
      }

      if(tab.key == "print"){
        this.getBarcode()

      }
      this.isEditingDock = false;
      this.editDockForm = {};
    },

    getHubName(hubid) {
      this.input = {
        hubids: hubid,
      };
      axios({
        method: "POST",
        url: apiUrl.api_url_hubops + "expose/hubservicecenter/hubarray/get",
        data: this.input,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          if (result.data.ResultCode == 100) {
            this.hubName = result.data.ResponseData[0].HubName;
          }
        },
        (error) => {
          console.error(error);
        },
      );
    },
    getPaginationData(pageNum) {
      this.pageno = pageNum - 1;
      this.getActiveFileData();
    },

    applyFilters() {
      this.pageno = 0;
      this.getActiveFileData();
    },

    resetFilters() {
      this.filterOperation = { text: "", value: "" };
      this.filterDockId = "";
      this.filterhubId = "";
      (this.hubname = ""), (this.pageno = 0);
      this.getActiveFileData();
    },

    selectedStatus(option) {
      this.filterOperation = option;
    },

    selectDockType(option) {
      this.selectedDockType = option;
      this.editDockForm.dock_type = option ? option.text : "";
    },

    setSelectedHub(hubitem) {
      this.filterhubId = hubitem.value;
    },

    getActiveFileData(fileId) {
      this.hubLoading = "loading active file data...";
      const activeHubId = this.filterhubId || this.hubId;
      let url =
        apiUrl.api_url_hubops +
        `dockmaster/fileData?limit=${this.limit}&offset=${this.pageno * this.limit}&hubId=${activeHubId}`;
      if (fileId) {
        url += `&fileId=${fileId}`;
      }
      if (this.filterDockId) {
        url += `&dockId=${this.filterDockId}`;
      }
      if (this.filterOperation.text) {
        url += `&status=${this.filterOperation.text}`;
      }
      axios({
        method: "GET",
        url: url,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        async (result) => {
          if (result.data.ResultCode == 100) {
            this.dockFileData = result.data.ResponseData;

            this.totalRows = result.data.pagination.totalCount;
            this.pageCount = result.data.pagination.totalPages;
          } 
          else if(result.data.ResultCode == 101){
            this.dockFileData = [];
            this.totalRows = 0;
            this.pageCount = 0;   
            console.log("dockFileData", this.dockFileData);
          }
          else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          this.hubLoading = "";
        },
        (error) => {
          this.isLoadingSearch = false;
          console.error(error);
          this.hubLoading = "";
        },
      );
    },

    // Delete flow disabled per product decision — kept here for future re-enable.
    // openDeleteDockRow(data) {
    //   this.deleteRowId = { ...data };
    //   this.deleteModalShow = true;
    // },
    //
    // cancelDelete() {
    //   this.deleteModalShow = false;
    //   this.deleteRowId = "";
    // },
    //
    // confirmDelete() {
    //   this.deleteModalShow = false;
    //   this.takeDeleteAction();
    // },
    //
    // takeDeleteAction() {
    //   this.isLoadingSearch = true;
    //   const fileInput = {
    //     fileId: Number(this.deleteRowId.file_id),
    //     deletedBy: this.createdBy,
    //   };
    //   if (this.deleteRowId.dock_barcode) {
    //     fileInput.dockBarcode = String(this.deleteRowId.dock_barcode).trim();
    //   }
    //   if (this.deleteRowId.dock_id) {
    //     fileInput.dockId = String(this.deleteRowId.dock_id).trim();
    //   }
    //   if (!fileInput.dockBarcode && !fileInput.dockId) {
    //     this.isLoadingSearch = false;
    //     this.$alertify.error("Missing dock identifier for this row.");
    //     return;
    //   }
    //   axios({
    //     method: "POST",
    //     url: apiUrl.api_url_hubops + "dockmaster/deleteRow",
    //     data: fileInput,
    //     headers: {
    //       authorization: "authkey xB84JJ89Hd25",
    //     },
    //   }).then(
    //     (result) => {
    //       if (result.data.ResultCode == 100) {
    //         this.$alertify.success(result.data.ReturnMessage);
    //         this.getActiveFileData(this.deleteRowId.file_id);
    //       } else {
    //         this.$alertify.error(result.data.ReturnMessage);
    //       }
    //       this.isLoadingSearch = false;
    //     },
    //     (error) => {
    //       this.isLoadingSearch = false;
    //       console.error(error);
    //     },
    //   );
    // },

    openEditDockRow(data) {
      this.editDockForm = Object.assign({}, data);
      this.editDockForm.weighing_type = this.normalizeWeighingType(
        data.weighing_type,
      );
      this.editDockForm.preferred_bu = this.normalizePreferredBu(
        data.preferred_bu,
      );
      this.selectedDockType =
        this.dockTypeOptions.find(
          (opt) => opt.value == data.dock_type || opt.text == data.dock_type,
        ) || null;
      this.isEditingDock = true;
      this.currentTab = "editDock";
      this.editDockErrors = { max_vehicles: "", vehicle_capacity: "", dock_height: "" };
    },

    validateWholeNumber(rawValue, label) {
      if (rawValue === null || rawValue === undefined || rawValue === "") {
        return `The ${label} field is required.`;
      }
      const s = String(rawValue).trim();
      if (!/^-?\d+$/.test(s)) {
        return `The ${label} field must be a whole number (no decimals allowed).`;
      }
      if (Number(s) < 1) {
        return `The ${label} field must be 1 or more.`;
      }
      return "";
    },

    validatePositiveUpTo3Decimals(rawValue, label) {
      if (rawValue === null || rawValue === undefined || rawValue === "") {
        return `The ${label} field is required.`;
      }
      const s = String(rawValue).trim();
      if (!/^-?\d+(\.\d+)?$/.test(s)) {
        return `The ${label} field must be a number.`;
      }
      if (/^-?\d+\.\d{4,}$/.test(s)) {
        return `The ${label} field can have at most 3 decimal places.`;
      }
      if (Number(s) < 1) {
        return `The ${label} field must be 1 or more.`;
      }
      return "";
    },

    validateMaxVehicles() {
      this.editDockErrors.max_vehicles = this.validateWholeNumber(
        this.editDockForm.max_vehicles,
        "Max Vehicles",
      );
    },
    validateVehicleCapacity() {
      this.editDockErrors.vehicle_capacity = this.validatePositiveUpTo3Decimals(
        this.editDockForm.vehicle_capacity,
        "Vehicle Capacity",
      );
    },
    validateDockHeight() {
      this.editDockErrors.dock_height = this.validatePositiveUpTo3Decimals(
        this.editDockForm.dock_height,
        "Dock Height",
      );
    },
    validateEditDockNumericFields() {
      this.validateMaxVehicles();
      this.validateVehicleCapacity();
      this.validateDockHeight();
      return (
        !this.editDockErrors.max_vehicles &&
        !this.editDockErrors.vehicle_capacity &&
        !this.editDockErrors.dock_height
      );
    },

    normalizeWeighingType(value) {
      if (value === null || value === undefined) return "";
      const v = String(value).trim().toLowerCase();
      if (v === "dws") return "DWS";
      if (v === "manual") return "Manual";
      if (v === "tbc") return "TBC";
      return "";
    },

    normalizePreferredBu(value) {
      if (value === null || value === undefined) return "";
      const v = String(value).trim().toLowerCase().replace(/\s+/g, " ");
      const compact = v.replace(/\s+/g, "");
      if (v === "b2b") return "B2B";
      if (v === "b2c") return "B2C";
      if (v === "lh") return "LH";
      if (compact === "b2b-lh") return "B2B- LH";
      // Canonical value is "B2B and B2C LH" (matches BE `PREFERRED_BU`
      // whitelist). Accept the legacy "&" spelling too so any stored rows
      // written before the FE aligned still normalize into the dropdown
      // instead of silently rendering blank.
      if (compact === "b2bandb2clh" || compact === "b2b&b2clh") return "B2B and B2C LH";
      return "";
    },
    cancelEditDockRow() {
      this.isEditingDock = false;
      this.editDockForm = {};
      this.selectedDockType = null;
      this.currentTab = "upload";
      this.editDockErrors = { max_vehicles: "", vehicle_capacity: "", dock_height: "" };
    },

    submitEditDockRow() {
      const numericFieldsValid = this.validateEditDockNumericFields();
      this.$validator.validateAll().then((valid) => {
        if (!valid || !numericFieldsValid) return;

        const payload = {
          rowId: this.editDockForm.id,
          fileId: this.editDockForm.file_id,
          dock_type: this.editDockForm.dock_type,
          max_vehicles: Number(this.editDockForm.max_vehicles),
          vehicle_capacity: Number(this.editDockForm.vehicle_capacity),
          dock_height: Number(this.editDockForm.dock_height),
          weighing_type: this.editDockForm.weighing_type,
          preferred_bu: this.editDockForm.preferred_bu,
          status: this.editDockForm.status,
          camera_name: this.editDockForm.camera_name,
          modifiedBy: this.createdBy,
        };
        axios({
          method: "POST",
          url: apiUrl.api_url_hubops + "dockmaster/editRow",
          data: payload,
          headers: {
            authorization: "authkey xB84JJ89Hd25",
          },
        }).then(
          (result) => {
            if (result.data.ResultCode == 100) {
              this.$alertify.success(result.data.ReturnMessage);
              this.isEditingDock = false;
              this.currentTab = "upload";
              this.getActiveFileData();
            } else {
              this.$alertify.error(result.data.ReturnMessage);
            }
            this.isLoadingSearch = false;
          },
          (error) => {
            this.isLoadingSearch = false;
            console.error(error);
          },
        );
      });
    },

    uploadConfigFile(event) {
      this.failed = [];
      this.selectedFile = event.target[0].elements[0].files[0];

      if (this.selectedFile.size > 5242880) {
        this.$alertify.error(
          "Failed! Upload Max File Size Should Not Be Greater Than 5 MB",
        );
        return false;
      } else if (
        /\.(csv)$/i.test(this.selectedFile.name) ||
        /\.(zip)$/i.test(this.selectedFile.name)
      ) {
        this.isLoadingUpload = true;

        const fd = new FormData();
        fd.append("currentHubId",this.hubId)
        fd.append("uploadedBy", this.createdBy);
        fd.append("fileData", this.selectedFile);
        fd.append("fileName", this.selectedFile.name);
        axios
          .post(apiUrl.api_url_hubops + "dockmaster/upload", fd, {
            headers: {
              Authorization: "authkey xB84JJ89Hd25",
            },
          })
          .then(
            (result) => {
              if (result.data.ResultCode == 100) {
                this.$alertify.success(result.data.ReturnMessage);
                this.resetForm();
              } else {
                this.$alertify.error(result.data.ReturnMessage);
              }

              if (
                result &&
                result.data.failed &&
                result.data.failed.length > 0
              ) {
                this.failed = result.data.failed;
                console.log("failed", this.failed);
              }

              this.isLoadingUpload = false;
            },
            (error) => {
              console.error(error);
              this.isLoadingUpload = false;
              this.$alertify.error("Error Occured");
            },
          );
      } else {
        this.isLoadingUpload = false;
        this.$alertify.error(
          "Failed! Please Upload Only Valid Format: .csv OR .zip",
        );
      }
    },

    onUploadSubmit: function (res) {
      this.$validator
        .validateAll()
        .then((result) => {
          if (result) {
            this.uploadConfigFile(event);
            event.target.reset();
          }
        })
        .catch((error) => {
          this.$alertify.error("Error Occured");
        });
    },

    downloadConfig(file) {
      if (file.createdby == "AUTOMATED-TRIGGER") {
        this.downloadConfigbySingedUrl(file);
      } else {
        this.downloadConfigfromDB(file);
      }
    },

    downloadActiveConfig() {
      const activeRow = (this.dockFileData || []).find(
        (row) => row && row.file_id,
      );
      if (!activeRow) {
        this.$alertify.error("No active dock data available to download.");
        return;
      }
      const safeHub = String(this.hubName || "active").replace(/\s+/g, "_");
      this.downloadConfigfromDB({
        id: activeRow.file_id,
        filename: `dock_config_${safeHub}.csv`,
        createdby: "",
      });
    },

    downloadSampleCsv() {
      const csvFields = {
        facility_name: "Facility Name",
        dock_number: "Dock Number",
        dock_id: "Dock ID",
        dock_type: "Dock Type",
        max_vehicles: "Max Vehicles",
        vehicle_capacity: "Vehicle Capacity (Ft)",
        dock_height: "Dock Height (Ft)",
        weighing_type: "Weighing Type",
        preferred_bu: "Preferred BU",
        status: "Status",
        camera_name: "Camera Name",
      };
      const facility = this.hubName || "SampleHub";
      const sampleData = [
        {
          facility_name: facility,
          dock_number: "1",
          dock_id: "D-001",
          dock_type: "Running",
          max_vehicles: 2,
          vehicle_capacity: 22,
          dock_height: 4,
          weighing_type: "DWS",
          preferred_bu: "B2B",
          status: "Operational",
          camera_name: "CAM-01",
        },
        {
          facility_name: facility,
          dock_number: "2",
          dock_id: "D-002",
          dock_type: "Standalone",
          max_vehicles: 1,
          vehicle_capacity: 32,
          dock_height: 4,
          weighing_type: "Manual",
          preferred_bu: "B2C",
          status: "Under Maintenance",
          camera_name: "",
        },
        {
          facility_name: facility,
          dock_number: "3",
          dock_id: "D-003",
          dock_type: "Running",
          max_vehicles: 2,
          vehicle_capacity: 22,
          dock_height: 4,
          weighing_type: "DWS",
          preferred_bu: "B2B and B2C LH",
          status: "Non-Operational",
          camera_name: "CAM-03",
        },
      ];
      this.jsonToCSV("dock_master_sample.csv", sampleData, csvFields);
    },

    downloadConfigfromDB(file) {
      console.log(file);
      let fileData = [];
      this.isLoadingSearch = true;

      axios({
        method: "GET",
        url:
          apiUrl.api_url_hubops +
          "dockmaster/downloadConfigData?fileId=" +
          file.id +
          "&hubId=" +
          this.hubId,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          if (result.data.ResultCode == 100) {
            this.isLoadingSearch = false;

            fileData = result.data.ResponseData;
            console.log(fileData);

            let fileName = file.filename;
            let csvFields = {
              facility_name: "Facility Name",
              dock_number: "Dock Number",
              dock_id: "Dock ID",
              dock_type: "Dock Type",
              max_vehicles: "Max Vehicles",
              vehicle_capacity: "Vehicle Capacity (Ft)",
              dock_height: "Dock Height (Ft)",
              weighing_type: "Weighing Type",
              preferred_bu: "Preferred BU",
              status: "Status",
              camera_name: "Camera Name",
            };
            fileData = result.data.ResponseData
              .sort((a, b) => a.id - b.id)
              .map((item) => ({
              facility_name: item.facility_name,
              dock_number: item.dock_number,
              dock_id: item.dock_id,
              dock_type: item.dock_type,
              max_vehicles: item.max_vehicles,
              vehicle_capacity: item.vehicle_capacity,
              dock_height: item.dock_height,
              weighing_type: item.weighing_type,
              preferred_bu: item.preferred_bu,
              status: item.status,
              camera_name: item.camera_name || "", // Handle null values
            }));
            this.jsonToCSV(fileName, fileData, csvFields);
            this.$alertify.success("Success");
          } else {
            this.isLoadingSearch = false;
            this.$alertify.error(result.data.ReturnMessage);
          }
        },
        (error) => {
          this.isLoadingSearch = false;
          console.error(error);
        },
      );
    },

    downloadConfigbySingedUrl(file) {
      let fileData = [];
      this.isLoadingSearch = true;
      axios({
        method: "GET",
        url:
          apiUrl.api_url_hubops +
          "generateSorterConfigSignedUrl?fileName=" +
          file.filename +
          "&fileType=" +
          file.filetype +
          "&sorterHubId=" +
          file.sorterhubid,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          if (result.data.ResultCode == 100) {
            this.isLoadingSearch = false;
            this.url = result.data.ResponseData;
            var link = document.createElement("a");
            link.href = result.data.ResponseData;
            link.download = this.url;
            link.setAttribute("target", "_blank");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.$alertify.success(result.data.ReturnMessage);
          } else {
            this.isLoadingSearch = false;
            this.$alertify.error(result.data.ReturnMessage);
          }
        },
        (error) => {
          this.isLoadingSearch = false;
          console.error(error);
        },
      );
    },

    async exportFailedConfig() {
      this.isLoadingUpload = true;

      const fileName = "failedConfig";
      const csvFields = {
        "Facility Name": "Facility Name",
        "Dock Number": "Dock Number",
        "Dock ID": "Dock ID",
        "Dock Type": "Dock Type",
        "Max Vehicles": "Max Vehicles",
        "Vehicle Capacity (Ft)": "Vehicle Capacity (Ft)",
        "Dock Height (Ft)": "Dock Height (Ft)",
        "Weighing Type": "Weighing Type",
        "Preferred BU": "Preferred BU",
        Status: "Status",
        "Camera Name": "Camera Name",
        Reason: "Reason",
      };

      await this.jsonToCSV(fileName, this.failed, csvFields);
      this.isLoadingUpload = false;
    },

    selectFile(data) {
      this.selectedConfig = data;
      this.pendingActiveState = !data.is_active;

      if (data.is_active) {
        this.modalActionText = "Deactivate";
        this.modalPromptText = "Do you want to deactivate this file?";
      } else {
        this.modalActionText = "Activate";
        this.modalPromptText = "Do you want to activate this file?";
      }
      this.addmodalShow = true;
    },

    takeAction() {
      this.addmodalShow = false;
      this.updateConfigStatus(this.pendingActiveState);
    },

    jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
      var csvData = "";

      if (filename != "failedConfig")
        if (this.title != null) {
          // csvData += "Config Name" + "," + filename + "\n";
          //Header
          csvData += this.parseExtraData(this.title, "${data}\r\n");
        }
      //Fields
      const fieldKeys = Object.keys(csvfield).filter(
        (key) => skipFilter.indexOf(key) === -1,
      );
      csvData += fieldKeys.map((key) => csvfield[key]).join(",") + "\r\n";
      //Data
      data.forEach(function (item) {
        csvData += fieldKeys
          .map((key) => {
            let value = item[key];
            if (value === null || value === undefined) return "";
            let escapedCSV = value + "";
            if (escapedCSV.match(/[,"\n]/)) {
              escapedCSV = '"' + escapedCSV.replace(/\"/g, '""') + '"';
            }
            if (escapedCSV == "null") return "";
            return dateFilder.indexOf(key) != -1
              ? moment(escapedCSV).format("DD-MM-YYYY HH:mm:ss")
              : escapedCSV;
          })
          .join(",");
        csvData += "\r\n";
      });
      //Footer
      if (this.footer != null) {
        csvData += this.parseExtraData(this.footer, "${data}\r\n");
      }
      if (filename === "failedConfig") {
        filename += ".csv";
      }
      return this.export(csvData, filename, "application/csv");
      return csvData;
    },

    export(data, filename, mime) {
      let blob = this.base64ToBlob(data, mime);
      download(blob, filename, mime);
    },

    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)));
      let bstr = atob(base64);
      let n = bstr.length;
      let u8arr = new Uint8ClampedArray(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime,
      });
    },

    updateConfigStatus(isActive) {
      console.log(
        "Updating config status for file ID:",
        this.selectedConfig.id,
      );
      this.isLoadingSearch = true;
      let fileInput = {
        fileId: this.selectedConfig.id,
        isActive: isActive,
        modifiedBy: this.createdBy,
        currentHubId:this.hubId
      };
      console.log("File input for status update:", fileInput);
      axios({
        method: "POST",
        url: apiUrl.api_url_hubops + "dockmaster/toggleActive",
        data: fileInput,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage);
            this.getConfigFile();
            this.getActiveFileData(this.selectedConfig.id);
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          this.isLoadingSearch = false;
        },
        (error) => {
          this.isLoadingSearch = false;
          console.error(error);
        },
      );
    },

    closeStatusModal() {
      this.addmodalShow = false;
      this.selectedConfig = "";
    },

    getDockConfigLogs(data) {
      this.isLoadingSearch = true;
      axios({
        method: "GET",
        url:
          apiUrl.api_url_hubops + "dockmaster/auditHistory?fileId=" + data.id,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          if (result.data.ResultCode == 100) {
            this.configFileLogs = result.data.ResponseData;
            this.isLoadingSearch = false;
            this.showModal = true;
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          this.isLoadingSearch = false;
        },
        (error) => {
          this.isLoadingSearch = false;
          console.error(error);
        },
      );
    },

    closeModal() {
      this.showModal = false;
      this.configFileLogs = [];
    },

    getConfigFile() {
      this.serr = "";
      this.isLoadingSearch = true;
      this.fileDetails = [];
      axios({
        method: "GET",
        url: apiUrl.api_url_hubops + `dockmaster/history?currentHubId=${this.hubId}`,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        async (result) => {
          if (result.data.ResultCode == 100) {
            this.fileDetails = result.data.ResponseData;
            this.$alertify.success(result.data.ReturnMessage);
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          this.isLoadingSearch = false;
        },
        (error) => {
          this.isLoadingSearch = false;
          console.error(error);
        },
      );
    },

    resetForm(event) {
      this.isLoadingUpload = false;
      this.isLoadingSearch = false;
      this.filetype = "";
      this.configFile = "";
      this.failed = [];
      this.$validator.reset();
      this.errors.clear();
      if (event && event.target && event.target.form) {
        event.target.form.reset();
      }
    },


    selectBarcodePrint(barcodeList){
      this.printbarcode = barcodeList
    },

    printSelectedBarcode() {
      if (this.printbarcode.length === 0) {
        this.$alertify.error("Please select at least one barcode.");
        return;
      }
      this.generateBarcodePDF(this.printbarcode);
    },

    printAllBarcode() {
      if (this.barcodeList.length === 0) {
        this.$alertify.error("No barcodes available to print.");
        return;
      }
      this.generateBarcodePDF(this.barcodeList);
    },

    async generateBarcodePDF(list) {
      this.isLoadingSearch = true;
      const doc = new jsPDF('p', 'pt', 'a4');
      doc.setFont('helvetica', 'bold');
      doc.setLineWidth(0.5);

      // Layout: 2 stickers per A4 page, stacked vertically.
      // A4 = 595 × 842 pt. Sticker box = 495 × 340 pt, centered horizontally.
      const STICKERS_PER_PAGE = 2;
      const PAGE_WIDTH = 595;
      const STICKER_W = 495;
      const STICKER_H = 340;
      const STICKER_X = (PAGE_WIDTH - STICKER_W) / 2; // 50
      const STICKER_Y_TOP = 60;
      const STICKER_Y_GAP = 40;

      for (let i = 0; i < list.length; i++) {
        const value = list[i].dock_barcode;
        const label = `${list[i].dock_id}`;
        const barcode = await this.textToBase64Barcode(value);

        const positionOnPage = i % STICKERS_PER_PAGE;
        if (i > 0 && positionOnPage === 0) {
          doc.addPage();
        }

        const y = STICKER_Y_TOP + positionOnPage * (STICKER_H + STICKER_Y_GAP);
        const centerX = STICKER_X + STICKER_W / 2;

        // Sticker outline
        doc.rect(STICKER_X, y, STICKER_W, STICKER_H);

        // Barcode image — large, centered horizontally
        const barcodeW = 400;
        const barcodeH = 140;
        doc.addImage(barcode, 'JPEG', STICKER_X + (STICKER_W - barcodeW) / 2, y + 40, barcodeW, barcodeH);

        // Dock ID (big label)
        doc.setFontSize(28);
        doc.text(label, centerX, y + 230, { align: 'center' });

        // Dock barcode text (readable, below the Dock ID)
        doc.setFontSize(16);
        doc.text(value, centerX, y + 275, { align: 'center' });
      }

      doc.save('dock-barcode-sticker.pdf');
      this.isLoadingSearch = false;
    },

    async textToBase64Barcode(text) {
      const canvas = document.createElement('canvas');
      JsBarcode(canvas, text, {
        format: 'CODE39',
        displayValue: false,
        height: 150,
        margin: 10
      });
      return canvas.toDataURL('image/png');
    },

    resetPrintForm() {
      this.printbarcode = [];
    },

    getBarcode(){
      this.isLoadingSearch = true;
      axios({
        method: "GET",
        url:
          apiUrl.api_url_hubops + "dockmaster/generatedDockMasterBarcodes?hubId=" + this.hubId,
        headers: {
          authorization: "authkey xB84JJ89Hd25",
        },
      }).then(
        (result) => {
          if (result.data.ResultCode == 100) {
            this.barcodeList = result.data.ResponseData;
            console.log(this.barcodeList)
            this.isLoadingSearch = false;
          } else {
            this.$alertify.error(result.data.ReturnMessage);
          }
          this.isLoadingSearch = false;
        },
        (error) => {
          this.isLoadingSearch = false;
          console.error(error);
        },
      );

    }
  },
};



// WEBPACK FOOTER //
// ./src/views/components/DockMaster/DockMaster.js